import type { IBondScreenerView, TBondScreenerFiltersShape } from '@/creditflowresearch/domain/vo/Bondscreener';

export const DEFAULT_VIEW_OPTION = { value: 'default', label: 'Default View' } as const;

export interface IViewOption {
  value: string,
  label: string,
}

export const buildViewOptions = <TFilters extends TBondScreenerFiltersShape>(
  views: IBondScreenerView<TFilters>[],
): IViewOption[] => [
  DEFAULT_VIEW_OPTION,
  ...views.map((view) => ({ value: view.id, label: view.name })),
];
